import { registerLocaleData } from '@angular/common'
import { provideHttpClient, withInterceptors } from '@angular/common/http'
import localeEs from '@angular/common/locales/es-MX'
import localeEsExtra from '@angular/common/locales/extra/es-MX'
import {
  ApplicationConfig,
  LOCALE_ID,
  APP_INITIALIZER,
  Provider,
  isDevMode
} from '@angular/core'
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS, MAT_NATIVE_DATE_FORMATS, NativeDateAdapter } from '@angular/material/core'
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async'
import { provideRouter } from '@angular/router'
import { provideEffects } from '@ngrx/effects'
import { provideState, provideStore } from '@ngrx/store'
import { provideStoreDevtools } from '@ngrx/store-devtools'
import { routes } from './app.routes'
import { LigaService } from '@app/services/liga/ligas.service';
import { ServicioVersion } from '@app/services/version/servicio-version';
import { recaptchaInterceptor } from './interceptors/recaptcha.interceptor';
import { credentialsInterceptor } from './interceptors/credentials.interceptor';
registerLocaleData(localeEs, localeEsExtra)

export const provideLocaleConfig = (): Provider[] => {
  return [
    {
      provide: LOCALE_ID,
      useValue: 'es-MX'
    },
    {
      provide: DateAdapter,
      useClass: NativeDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: MAT_NATIVE_DATE_FORMATS
    }
  ]
}


// 2. Define la función Factory que se ejecutará al inicio
export function initializeLigaFactory(ligaService: LigaService): () => Promise<void> {
  return async () => {
    // Obtenemos el hostname (ej: "affemex.localhost", "otra-liga.dominio.com")
    const hostname = window.location.hostname;
    // Extraemos el slug (la primera parte)
    const slug = hostname.split('.')[0];

    console.log('Detectado slug:', slug);

    // Validamos el slug antes de llamar a la API
    if (ligaService.esSlugValido(slug)) {
      try {
        await ligaService.cargarLigaPorSlug(slug);
        console.log('Información de la liga cargada.');
      } catch (error) {
        console.error('Fallo crítico al cargar la liga:', error);
      }
    } else {
      console.warn(`Slug "${slug}" inválido o entorno de desarrollo sin slug. Usando configuración por defecto.`);
      // Opcional: Cargar una liga por defecto o mostrar un mensaje específico pendiente por definir
      ligaService.ligaActual.set(null);
    }
  };
}

// 3. Define el Provider para APP_INITIALIZER
const LIGA_INITIALIZER_PROVIDER: Provider = {
  provide: APP_INITIALIZER,
  useFactory: initializeLigaFactory,
  deps: [LigaService],
  multi: true,
};

export function initializeVersionFactory(servicioVersion: ServicioVersion): () => Promise<void> {
  return () => servicioVersion.inicializar();
}

const VERSION_INITIALIZER_PROVIDER: Provider = {
  provide: APP_INITIALIZER,
  useFactory: initializeVersionFactory,
  deps: [ServicioVersion],
  multi: true,
};


export const appConfig: ApplicationConfig = {
  providers: [
    provideLocaleConfig(),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([recaptchaInterceptor, credentialsInterceptor])),
    provideStore({}),
    provideStoreDevtools({
      maxAge: 25,
      logOnly: !isDevMode(),
      autoPause: true,
      trace: false,
      traceLimit: 75,
    }),
     LIGA_INITIALIZER_PROVIDER,
     VERSION_INITIALIZER_PROVIDER,

  ]
};
